"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.is-array");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.object.create");

require("core-js/modules/es.object.define-property");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.set-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _native = _interopRequireDefault(require("@emotion/native"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Label =
/*#__PURE__*/
_native["default"].Text(function (_ref) {
  var theme = _ref.theme,
      active = _ref.active;
  return {
    color: active ? theme.buttonActiveTextColor : theme.buttonTextColor,
    fontSize: 17
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var GroupTabs =
/*#__PURE__*/
function (_Component) {
  _inherits(GroupTabs, _Component);

  function GroupTabs() {
    _classCallCheck(this, GroupTabs);

    return _possibleConstructorReturn(this, _getPrototypeOf(GroupTabs).apply(this, arguments));
  }

  _createClass(GroupTabs, [{
    key: "renderTab",
    value: function renderTab(name, group) {
      var title = group.title;

      if (typeof title === 'function') {
        title = title();
      }

      var _this$props = this.props,
          onGroupSelect = _this$props.onGroupSelect,
          selectedGroup = _this$props.selectedGroup;
      return _react["default"].createElement(_reactNative.TouchableOpacity, {
        style: {
          marginTop: 5,
          marginRight: 15,
          paddingBottom: 10
        },
        key: name,
        onPress: function onPress() {
          return onGroupSelect(name);
        }
      }, _react["default"].createElement(Label, {
        active: selectedGroup === name
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var groups = this.props.groups;
      var entries = groups ? Object.entries(groups) : null;
      return entries && entries.length ? _react["default"].createElement(_reactNative.ScrollView, {
        horizontal: true,
        style: {
          marginHorizontal: 10,
          flexDirection: 'row',
          marginBottom: 10,
          borderBottomWidth: 1,
          borderBottomColor: '#ccc'
        }
      }, entries.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return _this.renderTab(key, value);
      })) : _react["default"].createElement(_reactNative.Text, null, "no groups available");
    }
  }]);

  return GroupTabs;
}(_react.Component);

GroupTabs.defaultProps = {
  groups: {},
  onGroupSelect: function onGroupSelect() {},
  selectedGroup: null
};
GroupTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  groups: _propTypes["default"].object,
  onGroupSelect: _propTypes["default"].func,
  selectedGroup: _propTypes["default"].string
};
var _default = GroupTabs;
exports["default"] = _default;